<div
  class="carousel"
  [ngClass]="{ 'carousel--shadowed': hasShadow, 'carousel--inline': inline }"
  [ngStyle]="{
    '--carousel-grid-xs': 100 / grid.xs + '%',
    '--carousel-grid-sm': 100 / grid.sm + '%',
    '--carousel-grid-md': 100 / grid.md + '%',
    '--carousel-grid-lg': 100 / grid.lg + '%',
    '--carousel-grid-xl': 100 / grid.xl + '%',
    '--carousel-gutter': gutter + 'px',
  }"
  (click)="carouselClick.emit()">
  <div
    class="carousel__wrapper"
    [ngClass]="{ 'carousel__wrapper--shade': !inline }">
    <div class="carousel__header">
      <ng-content select="[carouselTitle]"></ng-content>
      @if (!inline) {
        <div
          class="carousel__buttons"
          [ngClass]="{ hidden: !visibleButtons }"
          (click)="$event.stopPropagation(); $event.stopImmediatePropagation(); $event.preventDefault()">
          <ng-container [ngTemplateOutlet]="buttonPrev"></ng-container>
          <ng-container [ngTemplateOutlet]="buttonNext"></ng-container>
        </div>
      }
    </div>
    @if (inline) {
      <ng-container [ngTemplateOutlet]="buttonPrev"></ng-container>
    }
    <div
      #scrollingCarousel
      class="carousel__scroll"
      [ngClass]="{ 'carousel__scroll--inline': inline === true }">
      @for (element of trackedElements; track element.trackByProperty) {
        <div class="carousel__card">
          <ng-container
            [ngTemplateOutlet]="cardTemplate"
            [ngTemplateOutletContext]="{ $implicit: element }"></ng-container>
        </div>
      } @empty {
        <ng-container [ngTemplateOutlet]="empty"></ng-container>
      }
    </div>
    @if (inline) {
      <ng-container [ngTemplateOutlet]="buttonNext"></ng-container>
    }
  </div>
</div>

<ng-template #buttonPrev>
  <div
    class="carousel__buttons__wrapper"
    [ngClass]="{ 'carousel__buttons__wrapper--disabled': disableLeft }">
    <ng-content select="[carouselPrev]"></ng-content>
  </div>
</ng-template>
<ng-template #buttonNext>
  <div
    class="carousel__buttons__wrapper"
    [ngClass]="{ 'carousel__buttons__wrapper--disabled': disableRight }">
    <ng-content select="[carouselNext]"></ng-content>
  </div>
</ng-template>
